import { RedirectState } from './types/RedirectState';

export const buildSearchFromRedirectState = (state: RedirectState) => {
    const params = new URLSearchParams();

    (Object.entries(state) as [keyof RedirectState, string | null][]).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params.set(key, value);
        }
    });

    return params.toString();
};
